import { useEffect } from 'react';
import { useAddCoupon } from 'src/hooks/useAddCoupon';
import { useAuth } from 'src/hooks/useAuth';
import { AuthContext } from 'src/stores/Auth';
import { ProviderProps } from 'src/types/provider';

const AuthProvider: React.FC<ProviderProps> = ({ children }) => {
  const { execAddRegisteredCoupon } = useAddCoupon();
  const { user, isLoading } = useAuth();
  useEffect(() => {
    if (!user) return;
    execAddRegisteredCoupon(user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  return <AuthContext.Provider value={{ user, isLoading }}>{children}</AuthContext.Provider>;
};

export { AuthProvider };
